import { Config } from "../../../configurations/config";
export const Department_APIs = {
	EditTicketByAssignee_API: `${Config.server_url}${Config.api_prefix}/Ticket/EditTicketByAssignee`,
	GetDepartmentTickets_API: `${Config.server_url}${Config.api_prefix}/Ticket/GetDeptTickets?DepartmentId=`,
	GetDepartmentHistory: `${Config.server_url}${Config.api_prefix}/Ticket/GetTicketHistory?TicketId=`,
};
